import { faCircleLeft } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavItems } from "@helpers/navigation";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { BasicProps } from "./ComponentsInterface";
import { LMic } from "./LMic";

export const LHero = ({ ...props }: HeroProps): JSX.Element => {
    const classes = classNames(
        "hero",
        props.className,
        props.centered ? "has-text-centered" : "",
        props.size ? "is-" + props.size : "",
        props.type ? "is-" + props.type : "",
        props.isFullheight ? "is-fullheight" : ""
    );

    const bodyClasses = classNames("hero-body", "pt-0", props.contentCentered ? "is-justify-content-center" : "");

    return (
        <div className={classes}>
            {props.includeUnauthenticatedMenu && (
                <div className="hero-head">
                    <nav className="navbar mt-6 mx-6">
                        {/* Left side */}
                        <div className="navbar-brand is-flex-grow-1">
                            <div className="navbar-item">
                                <NavLink to={NavItems.Admin.Manage.Overview.path}>
                                    <FontAwesomeIcon icon={faCircleLeft} size={"xl"} />
                                    <span className="subtitle px-2 has-text-primary-blue">Home</span>
                                </NavLink>
                            </div>
                        </div>
                        {/* Center */}
                        <div className="hero-title navbar-item mw-70">
                            <span className="subtitle pr-6 has-text-dark-blue has-text-weight-medium is-size-3">
                                {props.navBarTitle}
                            </span>
                        </div>
                        {/* Right side */}
                        {props.showMic && (
                            <div className="hero-microphone navbar-item is-flex-grow-1 is-justify-content-flex-end">
                                <LMic showRec={props.micIsRecording} volume={props.micVolume} />
                            </div>
                        )}
                    </nav>
                </div>
            )}
            <div className={bodyClasses}>{props.children}</div>
        </div>
    );
};

interface HeroProps extends BasicProps {
    size?: "" | "small" | "medium" | "large" | "halfHeight" | "fullheight";
    type?: "" | "primary";
    includeUnauthenticatedMenu?: boolean;
    centered?: boolean;
    contentCentered?: boolean;
    isFullheight?: boolean;
    navBarTitle?: string;
    showMic?: boolean;
    micIsRecording?: boolean;
    micVolume?: number;
}
